<div #messageDiv id="messageDiv" class="permission-message">
  <ion-card *ngIf="permissionDenied$ | async" color="danger" class="m-0 p-d-5 b-r-0 ion-text-center"
    (click)="checkGeolocationPermissionByService();">
    <ion-card-content>
      <h4 class="font-size-15 f-w-600">{{'self_pwa_text.not_verify_location' | translate}}</h4>
      <h4 class="font-size-15 f-w-400">{{'self_pwa_text.click_on_to_verify' | translate}}</h4>
    </ion-card-content>
  </ion-card>
</div>